import React from 'react'
import HeatMap from "./HeatMaps"
import TableComponent from './TableComponent'

const Registration= () => {
  const positions = [
    "top-10 right-48",
    "top-[230px] right-[360px]",
    "top-[320px] right-[560px]",
    "top-[420px] right-[410px]",
    "bottom-[450px] left-[480px]",
    "bottom-[500px] right-[160px]",
    "bottom-[130px] left-1/3",
    "bottom-[200px] right-[480px]",
  ]

  return (
    <div className='md:px-24 px-4'>
     <div className="flex items-start justify-between md:mb-10 bg-[#F3F5F5]  w-full ">
      {/* Left Text Block */}
      <div>
        <div className="md:text-[24px]  text-[10px] font-bold text-[#979797] uppercase tracking-wide">
          Registrations <span className="text-[#03897B]">| Abattoir 1</span>
        </div>
        <div className="md:mt-4 mt-2 text-[8px] md:text-[14px] font-bold text-black">
          Registration number: F123456
        </div>
        <div className="md:text-[14px] text-[8px] md:mt-4 mt-2 text-black">
          Address: 1 Ent Road, XXXX
        </div>
      </div>

      {/* QR Image */}
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746116459/image_1712_nguxjy.png"
        alt="QR Code"
        className="md:w-[80px]  w-[28px] h-[28px] md:h-[80px] object-contain"
      />
    </div>
      <HeatMap />
  <TableComponent/>
  <div
      className="flex items-center justify-between  md:mt-6 mt-3 rounded-[5px] md:h-[91px] h-[40px] px-6  " 
      style={{
        backgroundColor: '#03897B',

      }}
    >
      {/* Logo + Phone Number */}
      <div className="flex items-center space-x-4">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746117188/image_1717_2_sq7ewc.png"
          alt="FarmNet Logo"
          className="md:h-16 h-2"
        />
        <span className="text-white font-light text-[8px] md:text-[24px] font-poppins">
        www.aha.co.za
        </span>
      </div>

      {/* Divider */}

      {/* Website URL */}
      <span className="text-white font-bold text-[8px] md:text-[20px] font-poppins ">
<span className='text-[#919291]'> Copyright</span> ©2025  Ad-Luck Holdings
      </span>
    </div>
<div className='md:h-14 h-3'></div>

    </div>
  )
}

export default Registration
